import { IDataLayerBase, IDataLayerCartContentBase } from './types';

export const triggerGtmEvent = (eventData: IDataLayerBase | IDataLayerCartContentBase): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
};
